import { createFileRoute } from "@tanstack/react-router";

import { BrowserConnectPage } from "../components/settings/BrowserConnectPage";

export const Route = createFileRoute("/settings/browser-connect")({
  component: BrowserConnectPage,
});
